<div class="content">
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.TASKS.ASK_AN_EMPLOYEE.EMPLOYEE"
    [dataService]="selectorService"
    [formControl]="employeeIdControl"
    [isRequired]="true"
    [multiple]="false"
    [supportDataPassing]="false"
    (finishedInitialLoading)="finishedLoadingSelector()"
  ></automata-automation-replacement-chips>
  <glxy-form-field>
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.TASKS.ASK_AN_EMPLOYEE.PROMPT_NAME' | translate }}
    </glxy-label>
    <input mat-input [formControl]="promptNameControl" />
    <glxy-hint>{{ 'AUTOMATIONS.EDITOR.TASKS.ASK_AN_EMPLOYEE.PROMPT_NAME_HINT' | translate }}</glxy-hint>
  </glxy-form-field>
  <glxy-form-field required="true">
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.TASKS.ASK_AN_EMPLOYEE.PROMPT' | translate }}
    </glxy-label>
    <textarea
      id="prompt"
      matInput
      [formControl]="promptControl"
      cdkTextareaAutosize
      cdkAutosizeMinRows="4"
      cdkAutosizeMaxRows="8"
      placeholder="{{ 'AUTOMATIONS.EDITOR.TASKS.ASK_AN_EMPLOYEE.PROMPT_PLACEHOLDER' | translate }}"
      #promptTextArea
    ></textarea>
    <automata-automation-variable-menu
      matSuffix
      [useGalaxyCompat]="true"
      (variableSelected)="insertVariable('prompt', promptControl, $event)"
    ></automata-automation-variable-menu>
    <glxy-hint align="right">{{ promptTextArea.value?.length || 0 }}/2000</glxy-hint>
  </glxy-form-field>
</div>
